import { cn } from "../lib/utils";

const SectionHeading = ({ label, className }) => {
  return (
    <h2 className={cn("bg-ap text-fontBackground text-center text-2xl font-bold", className)}>
      {label}
    </h2>
  );
};

export default SectionHeading;
